var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "embroidery-confirm-view"
  }, [_c('h5', {
    staticClass: "embroidery-confirm-view-title text-center"
  }, [_vm._v(_vm._s(_vm.translations.embroideryConfirmViewStep))]), _c('images-view', {
    ref: "imagesComponent",
    attrs: {
      "iconCheckColor": _vm.iconCheckColor,
      "itemsToPersonalize": _vm.itemsToPersonalize
    },
    on: {
      "images-loaded": _vm.imagesLoaded
    }
  }), _c('div', {
    staticClass: "embroidery-confirm-view-swatches"
  }, [_c('span', {
    staticClass: "embroidery-confirm-view-swatches-list"
  }, _vm._l(_vm.colors, function (item, index) {
    return _c('button', {
      key: index,
      staticClass: "embroidery-confirm-view-swatches-list-colors",
      style: {
        backgroundColor: item.name,
        color: _vm.iconCheckColor
      },
      attrs: {
        "id": "color-".concat(index),
        "aria-label": item.name,
        "aria-selected": _vm.iconCheckColor !== item.name
      },
      on: {
        "click": function click($event) {
          return _vm.changeFontColor(item);
        }
      }
    }, [_c('span', {
      staticClass: "icon-check"
    })]);
  }), 0)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }